import { ICompany } from "@hulanbv/afbouwkeur-packages";
import { CrudService } from "./crudService.abstract.service";

export const companyService = new (class Service extends CrudService<ICompany> {
  constructor() {
    super("company");
  }
})();
